"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var Replace = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M4.9999,11.9999 C4.9999,15.8599 8.1399,18.9999 11.9999,18.9999 C14.7039,18.9999 17.1519,17.4089 18.3029,14.9999 L18.3029,14.9999 L15.9999,14.9999 L15.9999,13.9999 L19.9999,13.9999 L19.9999,17.9999 L18.9999,17.9999 L18.9999,15.8679 C17.6069,18.3789 14.9259,19.9999 11.9999,19.9999 C7.5889,19.9999 3.9999,16.4109 3.9999,11.9999 L3.9999,11.9999 Z M11.9999,3.9999 C16.4109,3.9999 19.9999,7.5889 19.9999,11.9999 L19.9999,11.9999 L18.9999,11.9999 C18.9999,8.1399 15.8599,4.9999 11.9999,4.9999 C9.3059,4.9999 6.8479,6.5939 5.6959,8.9999 L5.6959,8.9999 L7.9999,8.9999 L7.9999,9.9999 L3.9999,9.9999 L3.9999,5.9999 L4.9999,5.9999 L4.9999,8.1449 C6.3929,5.6319 9.0799,3.9999 11.9999,3.9999 Z", fillRule: "evenodd" })));
};
Replace.displayName = 'Replace';
exports.default = Replace;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Replace.js.map